import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import post1 from "../../assets/images/post/post1.svg";
import post2 from "../../assets/images/post/post2.svg";
import post3 from "../../assets/images/post/post3.svg";
import post4 from "../../assets/images/post/post4.svg";
import "../../assets/css/custom.css";
class TabsTwo extends Component {
  render() {
    let tab1 = "연혁",
      tab2 = "수상 내역";

    const { tabStyle } = this.props;
    return (
      <div>
        {/* Start Tabs Area */}
        <div className="tabs-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Tabs>
                  <TabList className={`${tabStyle}`}>
                    <Tab>{tab1}</Tab>
                    <Tab>{tab2}</Tab>
                    {/* <Tab>{tab3}</Tab>
                    <Tab>{tab4}</Tab> */}
                  </TabList>

                  <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <span className="spantext">2021. 06</span>
                          <span className="spantext2">
                            중소벤처기업부 예비창업패기지 선정
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2021. 07.</span>
                          <span className="spantext2">예비 벤처기업 선정</span>
                        </li>
                        <li>
                          <span className="spantext">2021. 08.</span>
                          <span className="spantext2">
                            (주)엑스알에이아이 법인 설립
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2021. 12.</span>
                          <span className="spantext2">
                            엑센트리벤쳐스 LEVEL-X : 광주 AI 4기 우수상 입상
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2022. 02.</span>
                          <span className="spantext2">
                            AI 바우처 공급기업 선정
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2022. 05.</span>
                          <span className="spantext2">
                            중소벤처기업부 초기창업패키지 선정 광주북구
                            대학타운형 도시재생 뉴딜사업 아이디어팩토리
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2022. 12.</span>
                          <span className="spantext2">
                            중소벤처기업부 대-스타 해결사 플랫폼 인공지능 분야
                            대상
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2023. 02.</span>
                          <span className="spantext2">기업부설연구소 설립</span>
                        </li>
                        <li>
                          <span className="spantext">2023. 06.</span>
                          <span className="spantext2">
                            창업성장기술개발 디딤돌 R&D 지원사업 선정
                            프리팁스(Pre-Tips) 사업화 지원사업 선정
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2023. 11.</span>
                          <span className="spantext2">
                            NIA 주관 한국어 AI 경진대회(음성인식 부분) 우수상
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2024. 03.</span>
                          <span className="spantext2">
                            시민․지역기업 중심 AI 바우처 지원사업 선정 - LLM
                            기반 AI 챗봇 납품
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2024. 07.</span>
                          <span className="spantext2">
                            벤처기업 선정 Open Ko-LLM LeaderBoard : LLM 모델
                            성능 1위 기록
                          </span>
                        </li>
                        <li>
                          <span className="spantext">2024. 12.</span>
                          <span className="spantext2">
                            인공지능 활용한 이미지 생성 모델 구성에 대한 노하우
                            기술이전 완료 : 전남대학교 산학협력단
                          </span>
                        </li>
                      </ul>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className="single-tab-content">
                      <img className="w-25" src={post1} alt="" srcset="" />
                      <img className="w-25" src={post2} alt="" srcset="" />
                      <img className="w-25" src={post3} alt="" srcset="" />
                      <img className="w-25" src={post4} alt="" srcset="" />
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        {/* End Tabs Area */}
      </div>
    );
  }
}

export default TabsTwo;
